<template>
  <div id="search" class="techservice_wrapper">
    <v-header :status="true" />
    <div class="search" @click="contactUs">
      <img
        style="width:100%;cursor: pointer;"
        src="../assets/img2/home2_2x.png"
      />
      <!-- <div>
        <img src="../assets/img2/search_icon.png" />
        <input placeholder="搜索支持" />
      </div> -->
    </div>
    <div class="device">
      <div style="text-align: center;padding-top: 190px;">
        <img style="width:979px" src="../assets/img2/tech_devices.png" />
      </div>
      <div style="background-color:#F7F7F7;margin: 128px 0px;">
        <img style="width:100%;" src="../assets/img2/th_line.png" />
      </div>
      <div style="margin:0 auto;text-align: center;">
        <img src="../assets/img2/tech_service_txt.png" />
      </div>
      <div>
        <div id="remotesupport" class="service-menue-box">
          <div><img src="../assets/img2/tech_service_menue_1.png" /></div>
          <div><img src="../assets/img2/tech_service_menue_2.png" /></div>
          <div><img src="../assets/img2/tech_service_menue_3.png" /></div>
          <div><img src="../assets/img2/tech_service_menue_4.png" /></div>
        </div>
        <div id="questionanswers"></div>
      </div>
    </div>
    <div style="background-color:#F7F7F7;margin: 128px 0px;">
      <img style="width:100%;" src="../assets/img2/th_line.png" />
    </div>
    <div class="footer" id="footer">
      <div style="margin:0 auto;text-align: center;">
        <img src="../assets/img2/tech_contact_txt.png" />
      </div>
      <div class="contact-box">
        <div @mouseenter="mouseover(1)" @mouseleave="selecteIndex = 0">
          <img
            :src="
              selecteIndex == 1
                ? require('../assets/img2/tech_phone_blue.png')
                : require('../assets/img2/tech_phone.png')
            "
          />
          <div :style="{ color: selecteIndex == 1 ? '#115ff1' : '#323232' }">
            0755-26928221
          </div>
        </div>
        <div
          style="position: relative"
          @mouseenter="mouseover(2)"
          @mouseleave="selecteIndex = 0"
        >
          <img
            :src="
              selecteIndex == 2
                ? require('../assets/img2/tech_wx_blue.png')
                : require('../assets/img2/tech_wx.png')
            "
          />
          <div :style="{ color: selecteIndex == 2 ? '#115ff1' : '#323232' }">
            微信
          </div>
          <img
            v-if="selecteIndex == 2"
            class="wx-box"
            src="../assets/img2/wx_code.png"
          />
        </div>
        <div @mouseenter="mouseover(3)" @mouseleave="selecteIndex = 0">
          <img
            :src="
              selecteIndex == 3
                ? require('../assets/img2/tech_wb_blue.png')
                : require('../assets/img2/tech_wb.png')
            "
          />
          <div :style="{ color: selecteIndex == 3 ? '#115ff1' : '#323232' }">
            微博
          </div>
        </div>
        <div
          style="position: relative"
          @mouseenter="mouseover(4)"
          @mouseleave="selecteIndex = 0"
        >
          <img
            :src="
              selecteIndex == 4
                ? require('../assets/img2/tech_tk_blue.png')
                : require('../assets/img2/tech_tk.png')
            "
          />
          <div :style="{ color: selecteIndex == 4 ? '#115ff1' : '#323232' }">
            抖音
          </div>
          <img
            v-if="selecteIndex == 4"
            class="tk-box"
            src="../assets/img2/tk_code.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VHeader from "../components/Header.vue";
export default {
  name: "Techservice",
  components: { VHeader },
  data() {
    return {
      selecteIndex: 0,
    };
  },
  methods: {
    mouseover(index) {
      this.selecteIndex = index;
    },
    contactUs() {
      console.log("contactUs");
      document.getElementById("footer").scrollIntoView();
    },
  },
  mounted() {
    const that = this;
    if (document.getElementById(that.$route.query.hashId)) {
      document.getElementById(that.$route.query.hashId).scrollIntoView();
      that.$forceUpdate();
    }
    setTimeout(() => {
      if (document.getElementById(that.$route.query.hashId)) {
        document.getElementById(that.$route.query.hashId).scrollIntoView();
        that.$forceUpdate();
      }
    }, 10);
  },
};
</script>
<style lang="less" scoped>
div.techservice_wrapper {
  position: relative;
  min-width: 1420px;
  width: 100%;
  background-color: #f7f7f7;
  > div.search {
    position: relative;
    width: 100%;
    > img {
      position: relative;
      width: 100%;
    }
    > div {
      position: absolute;
      width: 1000px;
      height: 80px;
      padding: 20px;
      box-sizing: border-box;
      background: #ffffff;
      display: flex;
      flex-flow: row nowrap;
      align-content: center;
      top: calc(50% - 40px);
      left: calc(50% - 500px);
      > img {
        display: block;
        width: 40px;
        height: 40px;
        margin-right: 20px;
      }
      > input {
        position: relative;
        width: 100%;
        border: none;
        border-radius: 0;
        outline: none;
        box-shadow: 0px 0px 0px 0px; //去除阴影
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 40px;
        height: 40px;
        color: #999999;
        opacity: 1;
      }
      > input:focus {
        outline: none;
      }
    }
  }
  .device {
    background: #f7f7f7;
  }
  > div.footer {
    position: relative;
    width: 100%;
    background-color: #f7f7f7;
    padding: 0px 0px 200px 0px;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    > div:first-child {
      position: relative;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 40px;
      color: #333333;
      opacity: 1;
    }
    > div:last-child {
      position: relative;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 500;
      line-height: 40px;
      color: #333333;
      opacity: 1;
      display: flex;
      flex-flow: row nowrap;
      align-content: center;
      > img {
        width: 40px;
        height: 40px;
        margin-right: 8px;
      }
    }
  }
}
.service-menue-box {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 1260px;
  margin: 0 auto;
  margin-top: 40px;
  div {
    cursor: pointer;
    margin-top: 7px;
    width: 620px;
    height: 480px;
    text-align: center;
    > img {
      width: 587px;
    }
    &:hover {
      > img {
        transition: all 0.3s;
        width: 600px;
      }
    }
  }
}
.contact-box {
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  width: 1194px;
  height: 316px;
  font-size: 25px;
  color: #323232;
  margin-top: 64px;
  padding: 50px 0px;
  box-sizing: border-box;
  div {
    flex: 1;
    text-align: center;
    cursor: pointer;
  }
  > div :first-child {
    img {
      width: 63px;
      height: 69px;
    }
  }
  > div :nth-child(2) {
    img {
      width: 84px;
      height: 68px;
    }
  }
  > div :nth-child(3) {
    img {
      width: 84px;
      height: 68px;
    }
  }
  > div :last-child {
    img {
      width: 59px;
      height: 69px;
    }
  }
}
.tk-box {
  width: 210px;
  height: 249px;
  z-index: 100;
  position: absolute;
  top: 100px;
  left: 32px;
}
.wx-box {
  width: 217px;
  height: 260px;
  z-index: 100;
  position: absolute;
  top: 100px;
  left: 32px;
}
</style>
